import {
  Alert,
  AlertProps,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import GenericButton from "../GenericButton/GenericButton";

const GenericModal = ({
  children,
  isDisabled,
  isLoading,
  handleCancel,
  handleSave,
  title,
  description,
  isOpen = false,
  width,
  alertText,
  alertSeverity,
  saveText = "Save",
  cancelText = "Cancel",
  hideActions = false,
  disableRestoreFocus = false,
}: {
  children: React.ReactNode;
  isDisabled?: boolean;
  isLoading?: boolean;
  handleSave: (e: React.MouseEvent) => void;
  handleCancel?: () => void;
  title: string;
  description?: string | React.ReactNode;
  isOpen: boolean;
  width?: string;
  saveText?: string;
  cancelText?: string;
  alertText?: string;
  alertSeverity?: AlertProps["severity"];
  hideActions?: boolean;
  disableRestoreFocus?: boolean;
}) => {
  const handleSaveClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.stopPropagation();
    handleSave(e);
  };

  const handleCancelClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    handleCancel?.();
  };

  return (
    <Dialog
      className="rounded"
      open={isOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableRestoreFocus={disableRestoreFocus}
      sx={{
        "& .MuiPaper-root": {
          width: width,
        },
      }}
    >
      <div
        className={`transition-transform origin-center duration-500 
       ${isOpen ? "scale-100" : "scale-0"}`}
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        {description && (
          <DialogContent className="flex flex-col gap-2 pb-4">
            <DialogContentText id="alert-dialog-description">
              {description}
            </DialogContentText>
            {alertText && (
              <Alert
                severity={alertSeverity}
                sx={{ fontSize: "0.875rem", maxWidth: "100%" }}
              >
                {alertText}
              </Alert>
            )}
          </DialogContent>
        )}

        <DialogContent className="flex flex-col gap-2.5 pt-0">
          {children}
        </DialogContent>
        <DialogActions>
          {!hideActions && (
            <>
              {handleCancel && (
                <GenericButton
                  id="basic-button"
                  onClick={handleCancelClick}
                  text={cancelText}
                  variant="outlined"
                  color="inherit"
                />
              )}
              <GenericButton
                isDisabled={isDisabled || isLoading}
                id="basic-button"
                variant="contained"
                onClick={handleSaveClick}
                text={saveText}
                color="primary"
                {...(isLoading && {
                  startIcon: <CircularProgress size={16} color="inherit" />,
                })}
              />
            </>
          )}
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default GenericModal;
